import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { personalInfo } from '../../data/content';
import { calculateYearsOfExperience, calculateTotalArticles, calculateCompletedProjects } from '../../utils/profileUtils';
import projects from '../Projects/projects-list.json';
import substackPosts from '../Substack/posts/posts-list.json';
import './Home.css';

const Home = () => {
  const yearsOfExperience = calculateYearsOfExperience();
  const totalArticles = calculateTotalArticles();
  const completedProjects = calculateCompletedProjects();
  const extensionProjects = projects.filter(p => p.category === 'extension');
  const mobileProjects = projects.filter(p => p.category === 'mobile');
  const featuredNewsletter = substackPosts.slice(0, 2);

  return (
    <>
      <Helmet>
        <title>Victor Barbarosh - Full-Stack Developer Portfolio</title>
        <meta name="description" content={personalInfo.description} />
      </Helmet>

      <section className="welcome-section">
        <h1>Welcome to My Portfolio</h1>
        <p className="intro-text">{personalInfo.description}</p>

        <div className="highlights">
          <div className="highlight-item">
            <span className="highlight-number">{yearsOfExperience}+</span>
            <span className="highlight-label">Years Experience</span>
          </div>
          <Link to="/writing" className="highlight-item clickable">
            <span className="highlight-number">{totalArticles}</span>
            <span className="highlight-label">Articles Published</span>
          </Link>
          <Link to="/projects" className="highlight-item clickable">
            <span className="highlight-number">{completedProjects}</span>
            <span className="highlight-label">Projects Completed</span>
          </Link>
        </div>

        <div className="mission-statements">
          <div className="mission-item">
            <h3>🎯 Mission</h3>
            <p>Building secure, privacy-first software that empowers users while keeping their data where it belongs — on their devices.</p>
          </div>
          <div className="mission-item">
            <h3>📚 Continuous Learning</h3>
            <p>I believe there's no learning without reading. From writing for <a href="https://www.baeldung.com/author/victorbarbarosh" target="_blank" rel="noopener noreferrer">Baeldung</a> to exploring creative freedom on <a href="https://medium.com/@geeks.sw.gig" target="_blank" rel="noopener noreferrer">Medium</a> and curating security insights in <a href="https://thecybersecurity.substack.com/" target="_blank" rel="noopener noreferrer">The Cybersecurity Newsletter</a>.</p>
          </div>
          <div className="mission-item">
            <h3>🔐 Security Mindset</h3>
            <p>Every project I build — from browser extensions to mobile apps — is crafted with security and confidentiality at its core. DevSecOps isn't just a practice, it's a philosophy.</p>
          </div>
        </div>
      </section>

      <section className="projects-section">
        <h2>Featured</h2>
        
        <h3 className="project-category-title">
          <img src="/portfolio/assets/images/cybersecurity-newsletter-logo.png" alt="" className="category-logo" />
          The Cybersecurity Newsletter
        </h3>
        <div className="featured-articles-list">
          {featuredNewsletter.map((post) => (
            <Link key={post.id} to={`/substack/${post.id}`} className="featured-article-item">
              <span className="featured-article-title">{post.title}</span>
              <span className="featured-article-date">{new Date(post.datePublished).toLocaleDateString()}</span>
            </Link>
          ))}
        </div>
        <Link to="/substack" className="view-all-link">View all issues →</Link>

        <h3 className="project-category-title">🌐 Browser Extensions</h3>
        <div className="featured-projects-grid">
          {extensionProjects.map((project) => (
            <Link key={project.id} to={`/projects/${project.id}`} className="featured-project-card">
              {project.logo && <img src={project.logo} alt="" className="featured-project-logo" />}
              <div className="featured-project-info">
                <h3>{project.title}</h3>
                <p>{project.briefSummary}</p>
              </div>
            </Link>
          ))}
        </div>

        <h3 className="project-category-title">📱 Mobile Apps</h3>
        <div className="featured-projects-grid">
          {mobileProjects.map((project) => (
            <Link key={project.id} to={`/projects/${project.id}`} className="featured-project-card">
              {project.logo && <img src={project.logo} alt="" className="featured-project-logo" />}
              <div className="featured-project-info">
                <h3>{project.title}</h3>
                <p>{project.briefSummary}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/*<section className="cta-section">*/}
      {/*  <h2>Let's Work Together</h2>*/}
      {/*  <p>I'm always interested in new opportunities and challenging projects.</p>*/}
      {/*  <div className="cta-buttons">*/}
      {/*    <button className="cta-primary">Get In Touch</button>*/}
      {/*    <button className="cta-secondary">View Resume</button>*/}
      {/*  </div>*/}
      {/*</section>*/}
    </>
  );
};

export default Home;
